import { HTTP } from '../services'

export default new (class QuoteService {
  // Send a quote via API. Optional `message` overrides the default sentence
  // shown inside the quote details block in the email.
  sendQuote (quoteId, message = null) {
    const payload = {}
    if (message !== null && message !== undefined) {
      payload.message = message
    }
    return HTTP.post('/v1/quotes/' + quoteId + '/send', payload)
  }

  // Get quote by ID
  getQuoteById (quoteId) {
    return HTTP.get('/v1/quotes/' + quoteId)
  }

  // Get quote by lead event ID, venue ID and version
  getQuoteByVersion (leadEventId, venueId, version) {
    return HTTP.get(`/v1/lead-event/${leadEventId}/quotes/venue/${venueId}/version/${version}`)
  }

  // Rep-initiated cancellation of the client's pending quote request for a
  // venue on a lead event. Aborts the quote request that hasn't been
  // fulfilled yet (e.g. if it was raised by accident). Does NOT cancel an
  // already-accepted quote — the API responds with 409 in that case.
  cancelQuoteRequestByRep (leadId, leadEventId, venueId) {
    return HTTP.post(`/v1/leads/${leadId}/events/${leadEventId}/venue/${venueId}/quote/cancel-request`)
  }
})()